import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import {
  ConfirmationService,
  MessageService,
  PrimeNGConfig,
} from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TreeModule } from 'primeng/tree';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';

const initializeAppFactory = (primeConfig: PrimeNGConfig) => () => {
  // ......
  primeConfig.ripple = true;
};

@NgModule({
  declarations: [],
  providers: [
    ConfirmationService,
    MessageService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [PrimeNGConfig],
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MessagesModule,
    MessageModule,
    PanelMenuModule,
    MenubarModule,
    SplitButtonModule,
    PanelModule,
    CardModule,
    CalendarModule,
    TabViewModule,
    CheckboxModule,
    TableModule,
    DialogModule,
    ConfirmPopupModule,
    ToastModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    PaginatorModule,
    ToggleButtonModule,
    BadgeModule,
    ChipModule,
    SkeletonModule,
    MenuModule,
    ImageModule,
    TriStateCheckboxModule,
    StepsModule,
    InputTextareaModule,
    FileUploadModule,
    ConfirmDialogModule,
    SidebarModule,
    ScrollerModule,
    DragDropModule,
    PickListModule,
    DividerModule,
    PasswordModule,
    MultiSelectModule,
    TagModule,
    SelectButtonModule,
    RadioButtonModule,
    ScrollPanelModule,
    BreadcrumbModule,
    ChartModule,
    TreeModule,
  ],
  exports: [
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MessagesModule,
    MessageModule,
    PanelMenuModule,
    MenubarModule,
    SplitButtonModule,
    PanelModule,
    CardModule,
    CalendarModule,
    TabViewModule,
    CheckboxModule,
    TableModule,
    DialogModule,
    ConfirmPopupModule,
    ToastModule,
    AutoCompleteModule,
    ProgressSpinnerModule,
    PaginatorModule,
    ToggleButtonModule,
    BadgeModule,
    ChipModule,
    SkeletonModule,
    MenuModule,
    ImageModule,
    TriStateCheckboxModule,
    StepsModule,
    InputTextareaModule,
    FileUploadModule,
    ConfirmDialogModule,
    SidebarModule,
    ScrollerModule,
    DragDropModule,
    PickListModule,
    DividerModule,
    PasswordModule,
    MultiSelectModule,
    TagModule,
    SelectButtonModule,
    RadioButtonModule,
    ScrollPanelModule,
    BreadcrumbModule,
    ChartModule,
    TreeModule,
  ],
})
export class PrimengModule { }
